import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {ScholarshipRoutingModule} from "./scholarship-routing.module";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {TableModule} from "../generic/table/table.module";
import {CourseService} from "../../../service/CourseService";
import {Scholarship} from "./scholarship";
import {NgSelectModule} from "@ng-select/ng-select";
import {DlDateTimePickerModule} from "angular-bootstrap-datetimepicker";
import {UserService} from "../../../service/UserService";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ScholarshipRoutingModule,
    NgxDatatableModule,
    TableModule,
    NgSelectModule,
    DlDateTimePickerModule,
  ],
  providers: [UserService],
  exports: [
    Scholarship
  ],
  declarations: [Scholarship]
})
export class ScholarshipModule {}
